export const getError = (error?: string | null): string | null => (typeof error === 'undefined' ? null : error);
